// extracted by mini-css-extract-plugin
module.exports = {"header":"UserHeader_header__XG_5I","headerInner":"UserHeader_headerInner__3we7-","back":"UserHeader_back__1pvMI","title":"UserHeader_title__3tYs9"};